import { createSlice } from "@reduxjs/toolkit"

const initialState = {
  globalErrors: {}
}

const globalErrorSlices = createSlice({
  name: 'globalErrors',
  initialState,
  reducers: {
    setGlobalErrors: (state, action) => {
      state.globalErrors = action.payload;
    }
  }
});

export const {
setGlobalErrors
} = globalErrorSlices.actions;

export default globalErrorSlices.reducer;